import { render, staticRenderFns } from "./CardRelatedStrategyProjects.vue?vue&type=template&id=50b9f57a"
import script from "./CardRelatedStrategyProjects.vue?vue&type=script&lang=js"
export * from "./CardRelatedStrategyProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports